import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogIn, Palette } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/editor");
  }, [user, loading, navigate]);

  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/editor";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center editor-shell font-editor px-6" dir="rtl">
      <div className="w-full max-w-md bg-white border border-[#E5E2D9] rounded-2xl p-10 shadow-sm">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-11 h-11 rounded-xl bg-[#4A5D4E] flex items-center justify-center">
            <Palette className="w-6 h-6 text-white" strokeWidth={1.6} />
          </div>
          <div>
            <p className="text-xs text-[#5C635C]">מערכת ניהול התוכן</p>
            <p className="font-display text-xl text-[#1A1D1A] font-bold">EmotionalSignal</p>
          </div>
        </div>
        <h1 className="text-2xl font-bold text-[#1A1D1A] mb-2">ברוכה הבאה 👋</h1>
        <p className="text-[#5C635C] leading-relaxed mb-8">
          כאן את מנהלת את האתר שלך — עורכת עמודים, מעלה תמונות ומפרסמת. ההתחברות מאובטחת דרך חשבון Google.
        </p>
        <button
          data-testid="login-google-btn"
          onClick={handleLogin}
          className="w-full flex items-center justify-center gap-3 bg-[#4A5D4E] hover:bg-[#3d4d41] text-white rounded-full py-3.5 font-semibold transition-colors"
        >
          <LogIn className="w-5 h-5" strokeWidth={1.8} />
          התחברות עם Google
        </button>
        <p className="text-xs text-[#8a8f89] mt-6 leading-relaxed">
          רק את, האמנית, יכולה להיכנס לממשק הניהול. המבקרים באתר לא רואים את המסך הזה.
        </p>
      </div>
    </div>
  );
}
